/* ------------------------------Toggle password -------------------------------*/
document.addEventListener("click", function (event) {
  // Check if the clicked element is the 'eyeIcon'
  if (event.target.classList.contains("newFieldIcon-passwordEye")) {
    // Toggle the eye icon state
    event.target.classList.toggle("fa-eye");
    event.target.classList.toggle("fa-eye-slash");
    event.target.classList.toggle("showPassword");

    // Find the input element associated with this icon using the `toggle` attribute
    const inputSelector = event.target.getAttribute("toggle");
    if (inputSelector) {
      const input = document.querySelector(inputSelector);

      if (input) {
        // Toggle the input type between 'password' and 'text'
        input.type = input.type === "password" ? "text" : "password";
      }
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const currentURL = window.location.href;
  const pageTitle = document.title;

  const shareButton = document.querySelector(".shareButton.main");
  const shareGroup = document.querySelector(".groupButton2");

  if (shareButton && shareGroup) {
    shareButton.addEventListener("click", function () {
      shareGroup.classList.toggle("active");
    });

    document.addEventListener("click", function (e) {
      if (!shareButton.contains(e.target) && !shareGroup.contains(e.target)) {
        shareGroup.classList.remove("active");
      }
    });
  }

  const shareButtons = document.querySelectorAll(".social-button");
  shareButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const platform = button.getAttribute("data-platform");

      let shareURL = "";
      switch (platform) {
        case "facebook":
          shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
          break;
        case "twitter":
          shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}&text=${encodeURIComponent(pageTitle)}`;
          break;
        case "linkedin":
          shareURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentURL)}`;
          break;
        case "pinterest":
          shareURL = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentURL)}&description=${encodeURIComponent(pageTitle)}`;
          break;
        case "whatsapp":
          shareURL = `https://wa.me/?text=${encodeURIComponent(pageTitle + " " + currentURL)}`;
          break;
        case "email":
          shareURL = `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(currentURL)}`;
          break;
        case "copy":
          navigator.clipboard.writeText(currentURL);
          return;
      }

      if (shareURL) {
        window.open(shareURL, "_blank", "noopener,noreferrer");
      }
    });
  });
});



// -------------------------------------------Register page D.O.B-------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const dayDropdown = document.getElementById("select-day");
  const monthDropdown = document.getElementById("select-month");
  const yearDropdown = document.getElementById("select-year");

  if (!dayDropdown || !monthDropdown || !yearDropdown) {
    console.error("Dropdown elements not found!");
    return;
  }

  for (let day = 1; day <= 31; day++) {
    let option = document.createElement("option");
    option.value = day;
    option.textContent = day;
    dayDropdown.appendChild(option);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  months.forEach((month, index) => {
    let option = document.createElement("option");
    option.value = index + 1;
    option.textContent = month;
    monthDropdown.appendChild(option);
  });

  const currentYear = new Date().getFullYear();
  const startYear = 1920;

  for (let year = currentYear; year >= startYear; year--) {
    let option = document.createElement("option");
    option.value = year;
    option.textContent = year;
    yearDropdown.appendChild(option);
  }
});

/* --------------------------------------------------- END ----------------------------------------------------*/

// Account mobile nav
if (window.innerWidth <= 750) {
  const navTrigger = document.getElementById("navTrigger");
  const navList = document.querySelector(".profile-navigation");

  navList?.classList.add("hidden");

  navTrigger?.addEventListener("click", function () {
    navList.classList.toggle("hidden");
    navTrigger.classList.toggle("navTriggerActive");
  });

  const navListItems = document.querySelectorAll(".profile-navigation li a");
  navListItems?.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const content = this.innerHTML;
      navTrigger.innerHTML = content; // Update innerHTML of navTrigger
      navList.classList.add("hidden");
      navTrigger.classList.toggle("navTriggerActive");
    });
  });
}


document.addEventListener('click', (event) => {
  if (event.target.classList.contains('smooth-scroll')) {
    event.preventDefault();
    const container = document.querySelector('#image-scroll-redirection');
    if (container) {
      const containerTop = container.offsetTop - 200; // No extra offset
      window.scrollTo({
        top: containerTop,
        behavior: 'smooth',
      });
    }
  }
});


// Badge Animation - Alternate Between Two Texts
class BadgeAnimation extends HTMLElement {
  constructor() {
    super();
    this.toggleState = false;
    this.interval = null;
  }

  connectedCallback() {
    // Find span inside the element
    this.badge = this
    if (!this.badge) return;

    this.badge1 = this.getAttribute('data-badge1') || "";
    this.badge2 = this.getAttribute('data-badge2') || "";

    // Initial text
    this.badge.textContent = this.badge1;

    // Start animation loop
    this.interval = setInterval(() => this.updateText(), 1500);
  }

  updateText() {
    const textNode = Array.from(this.badge.childNodes).find(
      n => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== ""
    );

    if (!textNode) return;

    // Fade out
    this.badge.classList.add('badge-fade-out');

    // Swap text
    setTimeout(() => {
      textNode.textContent = this.toggleState ? this.badge1 : this.badge2;
      this.badge.classList.remove('badge-fade-out');
      this.toggleState = !this.toggleState;
    }, 100); // match CSS duration
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('badge-animation', BadgeAnimation);